const namespace = 'wizard-steps/';
export const WIZARD_STEPS = Object.freeze({
    RESET_NEXT: namespace + 'reset_next',
    VALIDATE_NEXT: namespace + 'set_next',
});

export default {
    state: () => ({
        nextValid: false,
    }),
    getters: {},
    mutations: {
        [WIZARD_STEPS.RESET_NEXT]: state => {
            state.nextValid = false;
        },
        [WIZARD_STEPS.VALIDATE_NEXT]: (state, { valid }) => {
            state.nextValid = valid;
        },
    },
    actions: {},
};
